export default "__VITE_ASSET__lvMhfg8M__"